"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconActionDropDown = _interopRequireDefault(require("../../Icons/IconActionDropDown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  transform: rotate(\n    ", "\n  );\n  height: 1.6rem;\n  width: 1.6rem;\n  justify-content: center;\n  align-items: center;\n  margin-left: 4px;\n\n  /* svg {\n    transform: scale();\n  } */\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 1.3rem;\n  width: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  color: ", ";\n  vertical-align: middle;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var HeaderCell = function HeaderCell(_ref) {
  var width = _ref.width,
      className = _ref.className,
      children = _ref.children,
      isTitle = _ref.isTitle,
      onClick = _ref.onClick,
      active = _ref.active,
      order = _ref.order,
      otherProps = _objectWithoutProperties(_ref, ["width", "className", "children", "isTitle", "onClick", "active", "order"]);

  return _react.default.createElement(Th, _extends({
    width: width,
    isTitle: isTitle,
    className: className,
    onClick: onClick,
    active: active,
    order: order
  }, otherProps), _react.default.createElement(ThWrapper, null, children, _react.default.createElement(IconWrapper, {
    active: active,
    order: order
  }, _react.default.createElement(_IconActionDropDown.default, {
    color: "#505050"
  }))));
};

var Th = _styledComponents.default.th(_templateObject(), function (props) {
  return props.width;
}, function (_ref2) {
  var isTitle = _ref2.isTitle,
      active = _ref2.active;
  return isTitle || active ? '700' : '400';
}, function (props) {
  return props.isTitle ? "1.6rem" : "1.3rem";
}, function (_ref3) {
  var isTitle = _ref3.isTitle,
      active = _ref3.active;
  return isTitle || active ? '#5B5550' : '#A29C95';
});

var ThWrapper = _styledComponents.default.div(_templateObject2());

var IconWrapper = _styledComponents.default.div(_templateObject3(), function (_ref4) {
  var active = _ref4.active;
  return active ? 'flex' : 'none';
}, function (_ref5) {
  var active = _ref5.active,
      order = _ref5.order;
  return active && order === 'ascending' ? '180deg' : '';
});

HeaderCell.defaultProps = {
  otherProps: {},
  isTitle: false,
  width: 'unset',
  onClick: function onClick() {}
};
HeaderCell.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,
  children: _propTypes.node,

  /** The width of the tableCell element */
  width: _propTypes.string,

  /** Applies isTitle styling to the cell */
  isTitle: _propTypes.bool,
  onClick: _propTypes.func,
  order: _propTypes.string,
  active: _propTypes.bool
};
var _default = HeaderCell;
exports.default = _default;